import { $api } from "../../../../../services/request.config";
import { getEligibleDelegateStructEmployeesAction } from "../getEligibleDelegateStructEmployees.action";

const DEFAULT_LIMIT = 301;

export const getEligibleDelegateStructEmployeesThunkAction = (
    structCode,
    { setIsLoading, setLoadError, limit = DEFAULT_LIMIT },
) => async (dispatch) => {
    try {
        setIsLoading(true);
        setLoadError(false);
        // const response = await $api(
        //     `v1/manager/delegations/eligible-delegates/structs/${structCode}?limit=${limit}`,
        // );
        const response = await $api(
            `v1/manager/delegations/eligible-delegates/structs/${structCode}`,
        );
        if (response.status === 200) {
            dispatch(getEligibleDelegateStructEmployeesAction({
                employees: response.data.employees || [],
                limitExceeded: Boolean(response.data.limitExceeded),
            }));
        }
        setIsLoading(false);
    } catch (error) {
        setIsLoading(false);
        if (!error.response || error.response.status >= 500) {
            setLoadError(true);
        } else {
            dispatch(getEligibleDelegateStructEmployeesAction({ employees: [], limitExceeded: false }));
        }
    }
};
